/**
 * O valor exibido pelo input já vem mascarado (`-R$ 1.000.000,00`), então o sinal é lido do
 * próprio texto. Tentar converter a máscara em número quebra a partir da casa do milhão, quando
 * passa a existir mais de um separador de milhar.
 */
export const isNegativeValue = (value?: unknown): boolean => {
  if (value === null || value === undefined) return false

  const valueStr = String(value).trim()

  if (!/\d/.test(valueStr)) return false

  return valueStr.startsWith('-')
}
